import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import FrameworkUtils from 'utils/framework';
import { activeHideAutoReplenishSelector } from 'viewModel/selectors/testTarget/activeHideAutoReplenishSelector';

const { wrapHOC } = FrameworkUtils;

const fields = createSelector(activeHideAutoReplenishSelector, hideAutoReplenish => ({ hideAutoReplenish }));

const withChangeMethodCoreProps = wrapHOC(connect(fields));

export { withChangeMethodCoreProps };
